import UpgradeToGrowthModal from "@/components/ui/upgrade-to-growth-modal";
import { useUpgradeModal } from "@/hooks/use-upgrade-modal";

export default function UpgradeModalProvider() {
	const { isOpen, title, message, context, workspaceId, reviewLimit, userRole, closeUpgradeModal, maybeLater } = useUpgradeModal();

	return (
		<UpgradeToGrowthModal
			open={isOpen}
			onOpenChange={(open) => {
				if (!open) {
					closeUpgradeModal();
				}
			}}
			context={context}
			customTitle={title || undefined}
			customMessage={message || undefined}
			workspaceId={workspaceId}
			reviewLimit={reviewLimit}
			userRole={userRole}
			onMaybeLater={maybeLater}
		/>
	);
}
